import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Box, Flex, Button, Heading, Text, VStack, Spinner, Image, HStack, Menu, MenuButton, MenuList, MenuItem, IconButton, Container, SimpleGrid, } from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';

// Component Imports
import RegistrationForm from './components/RegistrationForm';
import AdminDashboard from './components/AdminDashboard';
import MemberDashboard from './components/MemberDashboard';
import MatrimonyForm from './components/MatrimonyForm';
import MatrimonyList from './components/MatrimonyList';
import BusinessForm from './components/BusinessForm';
import PublicMemberList from './components/PublicMemberList'; 
import BusinessList from './components/BusinessList';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './components/HomePage';
import logoImage from './assets/logo.jpeg';
import InfluencerForm from './components/InfluencerForm'; // ADD THIS
import InfluencerList from './components/InfluencerList';

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAdminAuthenticated(!!user);
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleAdminLogout = async () => {
    await signOut(auth);
  };

  if (isLoading) {
    return (
      <VStack h="100vh" justify="center" align="center">
        <Spinner size="xl" />
      </VStack>
    );
  }

  return (
    <Router>
      <Box>
        <Flex as="nav" bg="brand.800" color="white" p={4} justify="space-between" align="center" shadow="md">
            <Link to="/">
                <HStack spacing={3} align="center">
                    <Image
                        src={logoImage}
                        alt="Bagda Samaj Pragati Path Logo"
                        boxSize="40px"
                        objectFit="contain"
                    />
                    <Heading size="md">Bagda Samaj Pragati Path</Heading>
                </HStack>
            </Link>
            
            <Box display={{ base: 'none', md: 'block' }}>
              {/* Change variant prop to specific bg and color props */}
              <Button as={Link} to="/businesses" bg="brand.800" color="white" _hover={{ bg: "brand.700" }} mr={4}>
                  Businesses
              </Button>
              <Button as={Link} to="/member-dashboard" bg="brand.800" color="white" _hover={{ bg: "brand.700" }} mr={4}>
                  Dashboard
              </Button>
              <Button as={Link} to="/register" bg="brand.800" color="white" _hover={{ bg: "brand.700" }} mr={4}>
                  Register
              </Button>
              {isAdminAuthenticated ? (
                <Button onClick={handleAdminLogout} colorScheme="red">Admin Logout</Button>
              ) : (
                <Button as={Link} to="/admin/login" bg="brand.800" color="white" _hover={{ bg: "brand.700" }}>Admin</Button>
              )}
            </Box>

            <Box display={{ base: 'block', md: 'none' }}>
              <Menu>
                <MenuButton
                  as={IconButton}
                  aria-label='Options'
                  icon={<HamburgerIcon />}
                  variant='outline'
                  colorScheme='whiteAlpha'
                />
                <MenuList bg="brand.800">
                  <MenuItem as={Link} to="/businesses" bg="brand.800" _hover={{ bg: "brand.700" }}>
                    Businesses
                  </MenuItem>
                  <MenuItem as={Link} to="/member-dashboard" bg="brand.800" _hover={{ bg: "brand.700" }}>
                    Dashboard
                  </MenuItem>
                  <MenuItem as={Link} to="/register" bg="brand.800" _hover={{ bg: "brand.700" }}>
                    Register
                  </MenuItem>
                  {isAdminAuthenticated ? (
                    <MenuItem onClick={handleAdminLogout} color="red.300" bg="brand.800" _hover={{ bg: "brand.700" }}>
                      Admin Logout
                    </MenuItem>
                  ) : (
                    <MenuItem as={Link} to="/admin/login" bg="brand.800" _hover={{ bg: "brand.700" }}>
                      Admin
                    </MenuItem>
                  )}
                </MenuList>
              </Menu>
            </Box>
        </Flex>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegistrationForm />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/members" element={<PublicMemberList />} />
          <Route 
            path="/admin"
            element={
              <ProtectedRoute isAuthenticated={isAdminAuthenticated}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/member-dashboard" element={<MemberDashboard />} />
          <Route path="/matrimony-create" element={<MatrimonyForm />} />
          <Route path="/matrimony-profiles" element={<MatrimonyList />} />
          <Route path="/business-create" element={<BusinessForm />} />
          <Route path="/businesses" element={<BusinessList />} />
          <Route path="/influencers/create" element={<InfluencerForm />} /> {/* ADD THIS */}
          <Route path="/influencers" element={<InfluencerList />} /> 
        </Routes>
        
        <Box as="footer" bg="gray.800" color="gray.400" mt={20}>
          <Container maxW="container.xl" py={10}>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} textAlign={{ base: 'center', md: 'left' }}>
              <VStack align={{ base: 'center', md: 'flex-start' }} spacing={4}>
                <HStack align="center">
                  <Image src={logoImage} alt="Logo" boxSize="30px" />
                  <Heading size="md" color="white">Bagda Samaj Pragati Path</Heading>
                </HStack>
                <Text fontSize="sm">A unified platform for our community's growth and prosperity.</Text>
              </VStack>
              
              <VStack align={{ base: 'center', md: 'flex-start' }} spacing={2}>
                <Heading size="sm" color="white">Head Office Address</Heading>
                <Text fontSize="sm">Ramalaya</Text>
                <Text fontSize="sm">22A, Nehru Nagar, Near Kamla Nehru Nagar, Ajmer Road</Text>
                <Text fontSize="sm">Jaipur, Rajasthan - 302024</Text>
                <Heading size="sm" color="white">Branch Office Address</Heading>
                <Text fontSize="sm">Fashion Gallery</Text>
                <Text fontSize="sm">3,4 Vaidh Vatika Colony, New Sanganer Road</Text>
                <Text fontSize="sm">Jaipur, Rajasthan - 302019</Text>
              </VStack>

              <VStack align={{ base: 'center', md: 'flex-start' }} spacing={2}>
                <Heading size="sm" color="white">Contact Us</Heading>
                <Text fontSize="sm">Phone: +91 8890195535</Text>
              </VStack>
            </SimpleGrid>
            <Text textAlign="center" pt={10} fontSize="sm" borderTopWidth={1} borderColor="gray.700" mt={10}>
              © {new Date().getFullYear()} Bagda Samaj Pragati Path. All Rights Reserved.
            </Text>
          </Container>
        </Box>
      </Box>
    </Router>
  );
}

export default App;